import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@edtech-ui/core/models/admin-student-platform/admin-details';
import { AdminStudentPlatformService } from '@edtech-ui/core/services/admin-student-platform.service';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-admin-student-platform-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-student-platform-header.component.html',
  styleUrl: './admin-student-platform-header.component.scss'
})
export class AdminStudentPlatformHeaderComponent implements OnInit,OnDestroy{
  showNotification = false;
  showProfile = false;
  user!: User;
  private userId!: string;
  subscription = new Subscription();

  constructor(private adminuserService: AdminStudentPlatformService,
    private _toastr: ToastrService,
    private _authService: AuthServiceService,
    private router: Router,) { }

  ngOnInit(): void {
    this.userId = this.getUserIdFromStorage();
    if (this.userId) {
      this.loadUser();
    }
  }

  private getUserIdFromStorage(): string {
    const userId = localStorage.getItem('user_id');
    if (!userId) {
      console.error('User ID not found in localStorage');
      return '';
    }
    return userId;
  }

  loadUser(): void {
	this.subscription.add(
    this.adminuserService.getUserDetails(this.userId).subscribe({
      next: user => (this.user = user),
      error: err => console.error('User API error', err)
    })
  );
  }

  get initials(): string {
    if (!this.user) return '';
    return (
      this.user.first_name.charAt(0) +
      this.user.last_name.charAt(0)
    ).toUpperCase();
  }

  notifications = [
    { icon: 'attach_money', color: '#16a34a', bg: '#dcfce7', title: 'Payment Received', desc: '₹44,550 received for 15 user renewals', time: '2 min ago' },
    { icon: 'group_add', color: '#6366f1', bg: '#e0e7ff', title: 'New HOD Added', desc: 'Dr. Sarah Wilson joined Computer Science', time: '15 min ago' },
    { icon: 'error_outline', color: '#f59e0b', bg: '#fff7ed', title: 'Subscription Expiring', desc: '5 users expiring in next 7 days', time: '1 hour ago' },
    { icon: 'support_agent', color: '#8b5cf6', bg: '#f3e8ff', title: 'Support Ticket', desc: 'New ticket #1234 from Engineering dept', time: '2 hours ago' }
  ];


  toggleDropdown(type: 'notification' | 'profile', event: MouseEvent) {
    event.stopPropagation();
    if (type === 'notification') {
      this.showNotification = !this.showNotification;
      this.showProfile = false;
    } else {
      this.showProfile = !this.showProfile;
      this.showNotification = false;
    }
  }
  
  logout(event: MouseEvent): void {
    event.stopPropagation();
    this.subscription.add(
      this._authService.logout(this.router).subscribe()
    );
  }

	goToProfilePage(event: MouseEvent) {
		event.stopPropagation();
		this.router.navigate(['/admin-student-platform/profile']);
	}

  @HostListener('document:click')
  closeDropdowns() {
    this.showNotification = false;
    this.showProfile = false;
  }

  	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}